<template>
  <div v-if="item.isDynamicPanel">
    <component
      v-for="(i, k) in activePage.elements.filter(
        (m) =>
          m.dynamicPanelUUID == item.uuid &&
          item.states[0].uuid == m.dynamicPanelStateUUID
      )"
      :key="k"
      :style="
        getCommonStyle({
          ...(i.isHotZone
            ? { ...i.commonStyle, background: 'rgba(255,255,0,0.1)' }
            : i.isDynamicPanel
            ? { ...i.commonStyle, background: 'rgba(109,0,255,0.1)' }
            : i.commonStyle),
        })
      "
      class="element-on-edit-pane"
      :is="i.elName"
      v-bind="i.propsValue"
    >
        <dynamic-panel-self v-if="i.isDynamicPanel" :item="i"></dynamic-panel-self>
    </component>
  </div>
</template>

<script>
import { _qk_register_components_object } from "@client/plugins/index";
import { mapState, mapGetters } from "vuex";
import editorProjectConfig from "@client/pages/editor/DataModel";
export default {
  name: "dynamicPanelSelf",
  components: {
    // 批量注册qk组件
    ..._qk_register_components_object,
  },
  props: {
    item: Object,
  },
  data() {
    return {
      getCommonStyle: editorProjectConfig.getCommonStyle,
    };
  },
  computed: {
    ...mapState({
      projectData: (state) => state.editor.projectData,
      activePageUUID: (state) => state.editor.activePageUUID,
      activeElementUUID: (state) => state.editor.activeElementUUID,
      activeElementUUIDMore: (state) => state.editor.activeElementUUIDMore,
      activeElementGroupUUID: (state) => state.editor.activeElementGroupUUID,
      activeDynamicPanelUUID: (state) => state.editor.activeDynamicPanelUUID,
      activeDynamicPanelStateUUID: (state) =>
        state.editor.activeDynamicPanelStateUUID,
    }),
    ...mapGetters([
      "currentPageIndex",
      "activeElementIndex",
      "activeElement",
      "activePage",
      "activeDynamicPanel",
      "activeDynamicPanelState",
    ]),
  },
};
</script>

<style lang="scss" scoped>
.element-on-edit-pane {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
</style>
